import React, { useRef, useEffect, useContext } from "react";
import Scrollspy from "react-scrollspy";
import clsx from "clsx";
import PubSub from "pubsub-js";
import { _localizeField } from "../core/utils";
import { WrapperContext } from "./Layout";

const Aside = ({ input }) => {
  // console.log(input);
  const { isMobile } = useContext(WrapperContext);

  const asideRef = useRef();
  useEffect(() => {
    _onUpdate();
    // document.querySelector(".modules").addEventListener("scroll", _onScroll);
    // return () =>
    //   document
    //     .querySelector(".modules")
    //     .removeEventListener("scroll", _onScroll);

    window.addEventListener("scroll", _onScroll);
    return () => window.removeEventListener("scroll", _onScroll);
  }, []);

  const _onScroll = () => {
    if (isMobile) return;
    const { top } = asideRef.current.getBoundingClientRect();
    // const scrollTop = document.querySelector(".modules").scrollTop;
    // console.log(scrollTop);
    if (window.pageYOffset > 100) {
      // if (scrollTop > 100) {
      if (top <= 0) {
        asideRef.current.classList.add("is-sticky");
      } else {
        asideRef.current.classList.remove("is-sticky");
      }
    } else {
      asideRef.current.classList.remove("is-sticky");
    }
  };

  const _onUpdate = (target) => {
    if (!isMobile || !target) return;
    const { title } = target.dataset;
    // console.log(input);
    if (input.length === 1) {
      PubSub.publish("ASIDE_CURRENT", input[0].title);
    } else {
      PubSub.publish("ASIDE_CURRENT", title);
    }
  };
  const _onAsideClick = (id) => {
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
    });
  };

  const ids = input.map((el) => el.id);
  // console.log(input);
  return (
    <aside
      className={clsx("fL fSeg hidden-sm", `len-${input.length}`)}
      ref={asideRef}>
      <Scrollspy
        items={ids}
        currentClassName='is-current'
        onUpdate={_onUpdate}
        offset={-60}>
        {input.map((el, i) => (
          <li
            key={el.id}
            className='curp ttu'
            role='button'
            onClick={() => _onAsideClick(el.id)}>
            {/* {_localizeField(el.title)} */}
            {el.title}
          </li>
        ))}
      </Scrollspy>
    </aside>
  );
};

export default Aside;
